import { getWelfareBalance } from '@/common/integrations/menhir/employee/welfare/welfare.service';
import { IWelfareBalance } from '@/common/integrations/menhir/employee/welfare/welfare.types';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { QueryKey, UseQueryOptions, useQuery } from '@tanstack/react-query';

export function useGetWelfareBalance(
  config?: UseQueryOptions<IWelfareBalance, unknown, IWelfareBalance, QueryKey>
) {
  const { data: welfare, ...rest } = useQuery({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.WELFARE.BALANCE],
    queryFn: getWelfareBalance,
    ...config,
  });
  return { welfare, ...rest };
}
